class EnergyCalculator {

    constructor() {
    //    this.unit = unit;//foot or meter
    }

	//climate cfb, dfc, csb, csa, bsk, dfb, cfa
	//openings, per year
    CalculateEnergyLoss(doortype, climat, openings, widthmm, heightmm, insidetemp, uvalue){
		
		let FAM = doortype;
		let SPEED = false;
		if(FAM == 'OH1042S'){
			FAM = 'OH1042P';
			SPEED = true;
		}
		
		let uvaluedoor = uvalue;
		let CLIMATE_CLASS = climat.toLowerCase();
		let DLW = widthmm;
		let DLH = heightmm;
		let T_in = insidetemp;

		let vars = new Object();

		vars.C_p = 1007;      //J/(kg·K)   Specific heat of air
    	vars.rho_air = 1.293; //kg/m3      Density of air
    	vars.g = 9.81;        //m/s2       acceleration of gravity
    	vars.Cc_h = 0.5;      //[-]        correction coefficient
		vars.F_h = 30;        //[W/m3]     heating and cooling factor

		vars.BH = 8; //[m], building height
    	vars.BS = 5000; //[m2], building plant area
    	vars.h_hc = 24; //[h], heating and cooling hours per day

		vars = this._getClimatPreCalculations(vars, CLIMATE_CLASS, T_in);

		//load_traffic_class
		//vars = this._getTraficClass(vars, openings);

		//load_size_class
		vars = this._getSizeClass(vars, DLH, DLW);

		//load_air_permeability
        vars.air_permeability = 6; //'[m3/(m2·h)], see SP report PX28772rev1
		
		//load_door_weight
		if(FAM == "OH1042P"){
        	vars.avg_weight = 12; //[kg/m2]
		}else if(FAM == "OH1082P"){
        	vars.avg_weight = 15.4; //[kg/m2)]
    	}
		vars.doorweight = (DLW / 1000) * (DLH / 1000) * vars.avg_weight;
		
		//load_power
		if(SPEED){
			vars.average_power = 2.83; //'W/kg
			vars.mean_power_per_cycle = vars.doorweight * vars.average_power;
			vars.standby_power = 18; //'W
		}else{
			vars.average_power = 1.05; //'W/kg
			vars.mean_power_per_cycle = vars.doorweight * vars.average_power;
			vars.standby_power = 5; //'W
		}

		let powerloss_by_heat_transmission = vars.doorarea * uvaluedoor * vars.dT_year; //'[W]
		let air_permeability_by_wind = vars.air_permeability * Math.pow((vars.p_wind / 50.0),(2 / 3));
		let powerloss_by_air_leakage = vars.C_p * vars.rho_air * ((air_permeability_by_wind * vars.doorarea) / 3600.0) * vars.dT_year;
		let neutral_pressure_height_in_buiding = vars.BH / 2;
		let pressure_by_chimney_effect = vars.g * neutral_pressure_height_in_buiding * vars.rho_air * (vars.dT_year / (vars.To_average + 273.0));
		let air_permeability_by_chimney_effect = vars.air_permeability * Math.pow((pressure_by_chimney_effect / 50),(2 / 3));
		let powerlosses_by_air_leakage_chimney = vars.C_p * vars.rho_air * ((air_permeability_by_chimney_effect * vars.doorarea) / 3600.0) * vars.dT_year;
		let airflow_by_infiltration = vars.v_wind * vars.doorarea * vars.Cc_h;
		let powerloss_by_infiltration = vars.C_p * vars.rho_air * vars.dT_year * airflow_by_infiltration * (1 / 1000.0);
		let total_time_for_losses = (vars.BH * vars.BS) / airflow_by_infiltration;
		let heater_and_cooler_power = vars.F_h * vars.BH * vars.BS * (1 / 1000.0);
		let time_to_activate_heating_or_cooling = (1 - ((vars.dT_year - vars.dT_change) / vars.dT_year)) * total_time_for_losses;
				
		this._getCalculatedSpeed(vars, FAM, SPEED, DLH);

		let calculation_time_tb = Math.min(vars.OPENCLOSECYCLETIME, total_time_for_losses);
		let calculation_time_th = Math.min(vars.OPENCLOSECYCLETIME, time_to_activate_heating_or_cooling);
		let calculation_power = Math.min(powerloss_by_infiltration, heater_and_cooler_power);

		//'RESULTS
		let TRANSMISSION_LOSSES_YEAR = powerloss_by_heat_transmission * vars.h_hc * 365.0 / 1000.0;

		let air_leakage_LOSSES_YEAR = (powerloss_by_air_leakage * vars.c_w + powerlosses_by_air_leakage_chimney) * vars.h_hc * 365 / 1000;
		let air_infiltration_losses_year = (powerloss_by_infiltration * calculation_time_tb + calculation_power * (vars.OPENCLOSECYCLETIME - calculation_time_th)) * openings * vars.c_w * (vars.h_hc / 24) * (1 / 3600);
		let electrical_losses_year = ((vars.mean_power_per_cycle * openings * vars.OPENCLOSECYCLETIME) + (((365 * 24 * 3600.00) - (openings * vars.OPENCLOSECYCLETIME)) * vars.standby_power)) * (1 / 3600000);
		var total_losses_per_year = TRANSMISSION_LOSSES_YEAR + air_leakage_LOSSES_YEAR + air_infiltration_losses_year + electrical_losses_year;
		var total_losses_per_day = total_losses_per_year / 365;

		
		this._log(" -Energyclass: " + CLIMATE_CLASS);
		this._log(" -dTemp ext.-in.: " + parseFloat(vars.dT_year).toFixed(2) + "°C");
		this._log(" -Wind Speed: " + parseFloat(vars.v_wind).toFixed(2) + "m/s");
		this._log(" -Wind Pressure: " + parseFloat(vars.p_wind).toFixed(2) + "Pa");

		this._log(" -Building height: " + vars.BH + "m" );
		this._log(" -Building area: " + vars.BS + "m²" );
		this._log(" -Heating and Cooling time per day: " + vars.h_hc + "h");

		//this._log("Traffic class: " + vars.Traffic_Class );

		this._log("Size class: " + vars.Size_class);

		this._log("Air Permeability: " + vars.air_permeability + "m³/(m²·h)");

		this._log("Opening/closing time: " + parseFloat(vars.OPENCLOSECYCLETIME).toFixed(2) + "s");

		this._log("Mean opening/closing speed: " + parseFloat(vars.AVERAGE_OPENINGCLOSINGSPEED).toFixed(2) + "m/s");

		this._log("approx door weight:" + vars.doorweight + "kg");

		this._log("mean power per cycle: " + vars.mean_power_per_cycle + "W");

		this._log("Relative power per cycle: " + vars.average_power + "W/kg");

		this._log("Standby power: " + vars.standby_power + "W");

		this._log("Transmission losses:     " + parseFloat(TRANSMISSION_LOSSES_YEAR).toFixed(1) + " kW/year");
		this._log("Air leakage losses:      " + parseFloat(air_leakage_LOSSES_YEAR).toFixed(1) + " kW/year");
		this._log("Air infiltration losses: " + parseFloat(air_infiltration_losses_year).toFixed(1) + " kW/year");
		this._log("Electrical losses:       " + parseFloat(electrical_losses_year).toFixed(1) + " kW/year");
		
		return parseInt(total_losses_per_year);
	}

	VerifyEnergyValue(){

		console.log("8699.4 == " + this.CalculateEnergyLoss('OH1082P','Cfb', 4400, 5000, 4000, 20, 0.47) );
		console.log("244.9 == " + this.CalculateEnergyLoss('OH1082P','Csb', 440, 3000, 2500, 20, 0.78) );
		console.log("2739.4 == " + this.CalculateEnergyLoss('OH1082P','Cfa', 9000, 3000, 2500, 20, 0.68) );

		console.log("24031.4 == " + this.CalculateEnergyLoss('OH1042P','Dfc', 5000, 5000, 4000, 20, 1.2) );//norway. norland
		console.log("2773.8 == " + this.CalculateEnergyLoss('OH1042P','Csa', 4000, 3000, 4000, 20, 1.1) );//Portugal, lisbon
		console.log("894.3 == " + this.CalculateEnergyLoss('OH1042P','BSk', 400, 3000, 3000, 20, 1.3) );//Spain, Zaragoza

		console.log("5521.9 == " + this.CalculateEnergyLoss('OH1042S','Dfb', 9000, 6000, 3000, 20, 1.1) );//Turky, Bayburt
	}

    _log(str){
		//console.log(str);
    }

	_getClimatPreCalculations(calcVals, climat, T_in){
		
		//use cfd as default
		calcVals.To_h = 9.78;
		calcVals.C_h = 240;
		calcVals.To_c = 19.67;
		calcVals.C_c = 0;

		calcVals.v_wind = 8.41666666666667;
		calcVals.c_w = 0.3206;

		if(climat == 'dfc'){
			calcVals.To_h = 2.72;
			calcVals.C_h = 330;
			calcVals.To_c = 19;
			calcVals.C_c = 0;

			calcVals.v_wind = 7.41666666666667;
			calcVals.c_w = 0.3206;

		}else if(climat == 'csb'){
			calcVals.To_h = 14.17;
			calcVals.C_h = 150;
			calcVals.To_c = 21;
			calcVals.C_c = 0;

			calcVals.v_wind = 8.08333333333333;
			calcVals.c_w = 0.3206;

		}else if(climat == 'csa'){
			calcVals.To_h = 12.83;
			calcVals.C_h = 180;
			calcVals.To_c = 23.67;
			calcVals.C_c = 90;

			calcVals.v_wind = 8.16666666666667;
			calcVals.c_w = 0.3206;

		}else if(climat == 'bsk'){
			calcVals.To_h = 10.5;
			calcVals.C_h = 210;
			calcVals.To_c = 22.5;
			calcVals.C_c = 30;

			calcVals.v_wind = 7.5;
			calcVals.c_w = 0.3206;

		}else if(climat == 'dfb'){
			calcVals.To_h = 7.67;
			calcVals.C_h = 210;
			calcVals.To_c = 21.33;
			calcVals.C_c = 0;

			calcVals.v_wind = 8.66666666666667;
			calcVals.c_w = 0.3206;

		}else if(climat == 'cfa'){
			calcVals.To_h = 8.375;
			calcVals.C_h = 210;
			calcVals.To_c = 22.5;
			calcVals.C_c = 30;

			calcVals.v_wind = 5.16666666666667;
			calcVals.c_w = 0.3206;
		}

		calcVals.To_average = ((calcVals.To_h * calcVals.C_h) + (calcVals.To_c * calcVals.C_c)) / 365; //[°C] year average temperature at location
    
		//initializing standard temperatures
    	calcVals.dT_change = 2; //'degrees ± from Tin before heating/cooling starts
    	calcVals.Ti_Heating = T_in - calcVals.dT_change; //[°C]
    	calcVals.Ti_cooling = T_in + calcVals.dT_change; //[°C]

		//temperature differences
    	calcVals.dT_heating = calcVals.Ti_Heating - calcVals.To_h; //[°C]
    	calcVals.dT_cooling = calcVals.To_c - calcVals.Ti_cooling; //[°C]
    
		//yearly temperature difference
		calcVals.dT_year = ((calcVals.dT_heating * calcVals.C_h) + (calcVals.dT_cooling * calcVals.C_c)) / 365; //[°C]

		this._log("((" +  calcVals.dT_heating + " * " + calcVals.C_h + ") + (" + calcVals.dT_cooling +" * " + calcVals.C_c + ")) / 365");

		calcVals.p_wind = 0.5 * calcVals.rho_air * Math.pow(calcVals.v_wind, 2);

		return calcVals;
	}

	//_getTraficClass(vars, openings){
	//	if(openings <= 1000){
	//		vars.Traffic_Class = 'N1';
	//		vars.Traffic_rev_value = 500;
	//	}else if(openings <= 10000){
	//		vars.Traffic_Class = 'N2';
	//		vars.Traffic_rev_value = 5000;
	//	}else if(openings <= 100000){
	//		vars.Traffic_Class = 'N3';
	//		vars.Traffic_rev_value = 50000;
	//	}else if(openings <= 500000){
	//		vars.Traffic_Class = 'N4';
	//		vars.Traffic_rev_value = 250000;
	//	}else if(openings <= 1000000){
	//		vars.Traffic_Class = 'N5';
	//		vars.Traffic_rev_value = 750000;
	//	}else{
	//		vars.Traffic_Class = 'N6';
	//		vars.Traffic_rev_value = 1500000;
	//	}
	//	return vars;
	//}

	_getSizeClass(vars, DLH, DLW){
		let doorarea = (DLH / 1000) * (DLW / 1000)
		if(doorarea < 8){
			vars.Size_class = 'S1';
			vars.Size_rev_area = 4;
			vars.Size_rev_width = 2;
			vars.Size_rev_height = 2;
		}else if(doorarea < 12){
			vars.Size_class = 'S2';
			vars.Size_rev_area = 10;
			vars.Size_rev_width = 3;
			vars.Size_rev_height = 3.33;
		}else if(doorarea < 16){
			vars.Size_class = 'S3';
			vars.Size_rev_area = 14;
			vars.Size_rev_width = 4;
			vars.Size_rev_height = 3.5;
		}else if(doorarea < 25){
			vars.Size_class = 'S4';
			vars.Size_rev_area = 20;
			vars.Size_rev_width = 5;
			vars.Size_rev_height = 4;
		}else{
			vars.Size_class = 'S5';
			vars.Size_rev_area = 30;
			vars.Size_rev_width = 6;
			vars.Size_rev_height = 5;
		}
		vars.doorarea = doorarea;
		return vars;
	}

	_getCalculatedSpeed(vars, FAM, SPEED, DLH){
		if(FAM == "OH1042P" && SPEED){
			vars.OPENSPEED = 1;//openingspeed in [m/s]
			vars.CLOSESPEED = 0.7;//closingspeed in [m/s]
		}else{
			vars.OPENSPEED = 0.25; //'openingspeed in [m/s]
			vars.CLOSESPEED = 0.25; //'closingspeed in [m/s]
		}

		vars.OPENINGDURATION = ((DLH / 1000) / vars.OPENSPEED);// '[s]
		vars.CLOSINGDURATION = ((DLH / 1000) / vars.CLOSESPEED);// '[s]
		vars.OPENCLOSECYCLETIME = vars.OPENINGDURATION + vars.CLOSINGDURATION;// '[s]
		vars.AVERAGE_OPENINGCLOSINGSPEED = (2 * (DLH / 1000)) / vars.OPENCLOSECYCLETIME;// '[m/s]
		vars.OPENTIMER = (vars.OPENTIME * 60) + vars.OPENINGDURATION + vars.CLOSINGDURATION;// '[s]
	}


}

export { EnergyCalculator };


// WEBPACK FOOTER //
// ./src/assets/scripts/calculators/energy-calculator.js